// src/App.jsx
import { Box } from '@mui/material'
import { QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter as Router, useLocation } from 'react-router-dom'
import { ErrorProvider } from '@/data'
import { queryClient } from '@/data/services/api/queryClient'
import { AccessGate, AuthProvider } from '@/features/authentication'
import { ErrorBoundary, layoutStyles, useResponsive } from '@/features/shared-ui'
import { AppRoutes } from '@/routes/AppRoutes'

// Wrapper component to check current route
function AppContent() {
  const location = useLocation()
  const isDashboardPage = location.pathname.startsWith('/dashboard')
  const { isMobile } = useResponsive()

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        maxWidth: '100vw',
        overflow: 'hidden',
      }}
    >
      <Box
        component='main'
        sx={{
          flexGrow: 1,
          // Only add padding for non-dashboard pages
          p: isDashboardPage ? 0 : { xs: 2, md: 3 },
          bgcolor: 'background.default',
          minHeight: '100vh',
          width: '100%',
          overflow: 'auto',
          ...(isMobile && !isDashboardPage && layoutStyles.responsiveContainer),
        }}
      >
        {/* Only add top spacing for non-dashboard pages */}
        {!isDashboardPage && <Box sx={{ height: { xs: '48px', md: 0 } }} />}
        <ErrorBoundary>
          <AccessGate>
            <AppRoutes />
          </AccessGate>
        </ErrorBoundary>
      </Box>
    </Box>
  )
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorProvider>
        <AuthProvider>
          <Router>
            <AppContent />
          </Router>
        </AuthProvider>
      </ErrorProvider>
    </QueryClientProvider>
  )
}

export default App
